import React from 'react';
import { DecisionTreeRunResultFieldsFragment } from '../../../../generated/core-api/graphql-react-query';

interface DecisionTreeResultContextProps {
  expanded: boolean;
  setExpanded: (value: boolean) => void;
  result?: DecisionTreeRunResultFieldsFragment;
  generateReport(): void;
}

export const DecisionTreeResultContext = React.createContext<DecisionTreeResultContextProps | undefined>(undefined);

export default function useDecisionTreeResultContext() {
  const context = React.useContext(DecisionTreeResultContext);
  if (context === undefined) {
    throw new Error('useDecisionTreeResultContext must be used within a DecisionTreeResultContextProvider');
  }
  return context;
}
